import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { IconButton } from '@totalsoft/rocket-ui';
import { TableCell, TableRow } from '@mui/material';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { DELETE_EXCHANGE_RATE } from '../mutations';
import { useMutation } from 'hooks/apollo/useMutation';
import useConfirmDialog from 'features/common/components/confirm/useConfirmDialog';
import FlexBox from 'components/common/FlexBox';
import { useFieldDecimalPlacesConfig } from 'hooks';
import { exchangeRateModalVar } from 'features/exchangeRates/variables';

const ExchangeRateItem = ({ data }) => {
  const { t } = useTranslation();
  const confirm = useConfirmDialog();
  const { cvsChExRate } = useFieldDecimalPlacesConfig();

  const [pending, setPending] = useState(false);

  const [deleteExchangeRate] = useMutation(DELETE_EXCHANGE_RATE, {
    onError: () => {
      setPending(false);
    }
  });

  const handleDelete = useCallback(() => {
    confirm(
      () => {
        setPending(true);
        deleteExchangeRate({ variables: { input: { exchangeRateId: data.exchangeRateId } } });
      },
      { content: t('ExchangeRate.DeleteExchangeRate') }
    );
  }, [t, confirm, deleteExchangeRate, data]);

  return (
    <TableRow hover key={data.exchangeRateId}>
      <TableCell>{moment(data.exchangeRateDate).format('DD.MM.YYYY')}</TableCell>
      <TableCell>{data.bankName}</TableCell>
      <TableCell>{data.refCurrencyCode}</TableCell>
      <TableCell>{data.currencyCode}</TableCell>
      <TableCell>{data.exchangeRate1?.toFixed(cvsChExRate)}</TableCell>
      <TableCell>
        <FlexBox gap={0.5} justifyContent='end'>
          <IconButton
            type='edit'
            color='primary'
            size='small'
            variant='text'
            disabled={pending}
            tooltip={t('ExchangeRate.Edit')}
            onClick={() =>
              exchangeRateModalVar({
                open: true,
                item: {
                  exchangeRateId: data.exchangeRateId,
                  exchangeRateDate: data.exchangeRateDate,
                  partnerId: data.partnerId,
                  bankName: data.bankName,
                  refCurrencyId: data.refCurrencyId,
                  refCurrencyCode: data.refCurrencyCode,
                  currencyId: data.currencyId,
                  currencyCode: data.currencyCode,
                  exchangeRate1: data.exchangeRate1
                }
              })
            }
          />
          <IconButton
            type='delete'
            color='primary'
            size='small'
            variant='text'
            disabled={pending}
            tooltip={t('ExchangeRate.Delete')}
            onClick={handleDelete}
          />
        </FlexBox>
      </TableCell>
    </TableRow>
  );
};

ExchangeRateItem.propTypes = {
  data: PropTypes.object
};

export default ExchangeRateItem;
